import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
	Grid,
	Paper,
	TextField,
	Button,
	FormControl,
	InputLabel,
	OutlinedInput,
} from "@mui/material";
import Titlebar from "../../TitleBar";
import { Pagination, SearchTable, TableBody2, TableHeader } from ".";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import {
	applyFilter,
	emptyRows,
	getComparator,
	extractDate,
} from "../../../Utils/table";
import { StudenMenu, Zones } from "../../TitleList";
import {
	selectStudents,
	selectZones,
} from "../../Selectors/Master/OutwardSelectors";
import { fetchStudentData, fetchZoneData } from "../../../Store/PHPSlice/zone";
import { sendWhatsappMsg } from "../../../Store/PHPSlice/sendWhatsappMsg";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

const StudentRegWhatsapp = () => {
	const userdata = JSON.parse(sessionStorage.getItem("user"));
	const dispatch = useDispatch();
	// const getItems = useSelector(selectStudents);
	const [getItems, setGetItems] = useState([]);
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("empId");
	const [selected, setSelected] = useState([]);
	const [filterName, setFilterName] = useState("null");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [recordsPerPage, setRecordsPerPage] = useState(10);
	const [searchQuery, setSearchQuery] = useState("");
	const [firstIndex, setFirstIndex] = useState(0);
	const [lastIndex, setLastIndex] = useState(0);
	const [whatsappMsgValue, setWhatsappMsgValue] = useState("");
	const [images, setImages] = useState([]);
	const [image, setImage] = useState(null);
	const [selectedStudent, setSelectedStudent] = useState([]);
	const { Id } = useParams();

	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
	const [searchTerm, setSearchTerm] = useState("");
	const [formData, setFormData] = useState({
		studId: parseInt(Id),
		WhatsappMsg: "",
		whatsappImg: "",
	});

	useEffect(() => {
		const fetchStudentsData2 = async () => {
			const response = await axios.get(
				`${baseUrl}?apicall=getWStudentData`
			);
			// console.log(response,'res222222222');
			setGetItems(response.data);
		};
		fetchStudentsData2();

		if (userdata?.role !== "1") {
			dispatch(fetchStudentData({ userId: userdata?.ID }));
		} else {
			dispatch(fetchStudentData());
		}
	}, [dispatch]);

	if (!getItems) {
		return <h1>Loading...</h1>;
	}

	console.log(getItems, "getItems");

	const compData = Array.isArray(getItems.data)
		? getItems.data.map((item, index) => ({
				srNo: item.ID,
				zoneNm: item.zoneNm,
				schoolNm: item.schoolNm,
				studNm: item.studNm,
				age: item.age,
				std: item.std,
				div: item.div,
				ph: item.ph,
				serialNumber: index + 1,
		  }))
		: [];

	const handleSort = (event, id) => {
		const isAsc = orderBy === id && order === "asc";
		if (id !== "") {
			setOrder(isAsc ? "desc" : "asc");
			setOrderBy(id);
		}
	};
	const handleSelectAllClick = (event) => {
		if (event.target.checked) {
			const newSelecteds = compData.map((n) => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleClick = (event, srNo) => {
		// const selectedIndex = selected.indexOf(name);
		// console.log(selected, "selected values before");
		// let newSelected = [];
		// if (selectedIndex === -1) {
		//     newSelected = newSelected.concat(selected, name);
		// } else if (selectedIndex === 0) {
		//     newSelected = newSelected.concat(selected.slice(1));
		// } else if (selectedIndex === selected.length - 1) {
		//     newSelected = newSelected.concat(selected.slice(0, -1));
		// } else if (selectedIndex > 0) {
		//     newSelected = newSelected.concat(
		//         selected.slice(0, selectedIndex),
		//         selected.slice(selectedIndex + 1)
		//     );
		// }
		// console.log(newSelected, "selected values after");
		// setSelected(newSelected);

		//const selectedStudent = displayedData.find((data) => data.srNo === srNo);
		//setSelectedStudent(selectedStudent);
		const selectedIndex = selected.indexOf(srNo);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = [...selected, srNo];
		} else {
			newSelected = selected.filter((id) => id !== srNo); // remove if already selected
		}
		setSelected(newSelected);
	};

	const handleChange = (e) => {
		setWhatsappMsgValue(e.target.value);
	};

	const handleChangeImage = (e) => {
		//if (e.target.files)
		if (e.target.files && e.target.files[0]) {
			// const files = Array.from(e.target.files);
			// setImages(files);
			setImage(e.target.files[0]);
		}
	};

	const handleChangeCPage = (n) => {
		setCurrentPage(n);
	};
	const handlePrevPage = () => {
		if (currentPage !== firstIndex) {
			setCurrentPage(currentPage - 1);
		}
	};

	const handleNextpage = () => {
		if (currentPage !== lastIndex) {
			setCurrentPage(currentPage + 1);
		}
	};

	const handleRecordsPerPageChange = (event) => {
		setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
		setCurrentPage(0); // Reset current page when records per page changes
	};

	const totalCount = compData.length;
	const npages = Math.ceil(totalCount / recordsPerPage);
	const numbers = Array.from({ length: npages }, (_, i) => i + 1);
	const renderPaginationButtons = () => {
		let start = Math.max(0, currentPage - 5);
		let end = Math.min(npages, start + 9);

		if (end - start < 9) {
			start = Math.max(1, end - 9);
		}

		return numbers.slice(start - 1, end).map((n) => (
			<button
				key={n}
				className={`page-link ${currentPage === n - 1 ? "active" : ""}`}
				onClick={() => handleChangeCPage(n - 1)}
			>
				{n}
			</button>
		));
	};

	const handleFilterByName = (event) => {
		setPage(0);
		let value = event.target.value.trim();
		setFilterName(event.target.value);
	};
	// const dataFiltered = applyFilter({
	//     inputData: compData,
	//     comparator: getComparator(order, orderBy),

	// });
	// const notFound = !dataFiltered.length;

	const handleSearchChange = (event) => {
		setSearchTerm(event.target.value);
		setCurrentPage(1); // Reset to first page on search
	};

	const filteredData = (Array.isArray(compData) ? compData : []).filter(
		(item) => item?.studNm?.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const dataFiltered = applyFilter({
		inputData: filteredData,
		comparator: getComparator(order, orderBy),
	});

	const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
	const displayedData = dataFiltered.slice(
		(currentPage - 1) * itemsPerPage,
		currentPage * itemsPerPage
	);

	const pageNumbers = Array.from(
		{ length: totalPages },
		(_, index) => index + 1
	);
	const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

	const handleNextPageRange = () => {
		setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
	};

	const handlePreviousPageRange = () => {
		setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
	};

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	const handleItemsPerPageChange = (event) => {
		setItemsPerPage(Number(event.target.value));
		setCurrentPage(1); // Reset to first page on change
	};
	// console.log(displayedData);
	/*const handleSubmit = (e) => {
        e.preventDefault();
        if (!whatsappMsgValue.trim()) {
            alert("Please Enter Whatsapp Msg Value");
            return;
        }

        const data = new FormData();
        //console.log("Selected ", selectedStudent)
        //console.log("whatspp", whatsappMsgValue)

        data.append("studId", selectedStudent.srNo);
        data.append("WhatsappMsg", whatsappMsgValue);
        if (images) {
            data.append("whatsappImg", images);
        }
        console.log("whtimg=>", images);

        console.log("Form submitted!", data.keys);

        dispatch(sendWhatsappMsg({ postData: data, id: selectedStudent.srNo }))
            .unwrap()
            .then((result) => {
                console.log("POST request successful!", result);
            })
            .catch((error) => {
                console.error("Error submitting form:", error);
            });
    };*/
	const handleSubmit = (e) => {
		e.preventDefault();
		if (!whatsappMsgValue.trim()) {
			alert("Please Enter Whatsapp Msg Value");
			return;
		}
		/*else if (selectedStudent.length === 0) {
            alert("Please select at least one student");
            return;
        }*/
		selected.forEach((studId) => {
			const data = new FormData();
			data.append("studId", studId);
			data.append("WhatsappMsg", whatsappMsgValue);
			data.append("file", image);
			console.log("studId=>", studId);
			console.log("Msg=>", whatsappMsgValue);
			console.log("wImg=>", image);
			/*if (images.length > 0) {
                images.forEach((file) => {
                    data.append("whatsappImg[]", file[0]); // allow multiple files
                    console.log("wImg=>",file[0]);
                });
            }*/

			// console.log("studId=>",file[0]);
			/*  dispatch(sendWhatsappMsg({ postData: data, id: studId }))
                .unwrap()
                .then((result) => {
                    //console.log(`Message sent to student ${studId}`, result);

                    //window.location.reload();
                })
                .catch((error) => {
                    //  console.error(`Error sending to ${studId}:`, error);
                    alert(error);
                    //window.location.reload();
                });*/
			dispatch(sendWhatsappMsg({ postData: data, id: studId }));
		});
		alert("whatsapp Message Send Successully....");
		window.location.reload();
	};
	return (
		<>
			<Titlebar data={StudenMenu} />

			<div style={{ margin: "1% 0.5%" }}>
				<h2>Whatsapp Sending Message</h2>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Paper style={{ padding: "3vh", margin: "0" }}>
							<Grid container spacing={2}>
								<Grid item xs={6}>
									<label
										htmlFor="wwmsg"
										align="left"
										style={{ paddingRight: "20px" }}
									>
										Message:
									</label>

									<TextField
										label="Enter Whatsapp Message"
										id="WhatsappMsg" // unique ID for the input
										name="WhatsappMsg"
										variant="outlined"
										onChange={handleChange}
										style={{
											marginBottom: "20px",
											width: "400px",
										}}
									/>
								</Grid>
								<Grid item xs={6}>
									<label
										htmlFor="wimg"
										align="left"
										style={{ paddingRight: "20px" }}
									>
										Image:
									</label>
									<input
										type="file"
										className="form-control"
										label="Enter Whatsapp Message"
										id="whatsappImg" // unique ID for the input
										name="whatsappImg"
										variant="outlined"
										accept=".png,.jpg,.jpeg"
										onChange={handleChangeImage}
										style={{
											width: "400px",
											padding: "8px",
											border: "1px solid #ccc", // ✅ border
											borderRadius: "6px",
											marginBottom: "20px",
											cursor: "pointer",
											backgroundColor: "#fff",
										}}
									/>
								</Grid>

								<Grid item xs={12} textAlign="center">
									<Button
										variant="contained"
										color="primary"
										onClick={handleSubmit}
									>
										Send Whatsapp Message
									</Button>
								</Grid>
							</Grid>

							<SearchTable
								handleItemsPerPageChange={
									handleItemsPerPageChange
								}
								searchTerm={searchTerm}
								handleSearchChange={handleSearchChange}
								totalItems={filteredData?.length}
							/>

							<TableContainer
								style={{
									marginTop: "2%",
									border: "1px solid #ccc",
								}}
							>
								<Table>
									<TableHeader
										headCells={[
											{ id: "srNo", label: "Sr.No" },
											{
												id: "zoneNm",
												label: "Zone Name",
											},
											{
												id: "schoolNm",
												label: "School Name",
											},
											{
												id: "studNm",
												label: "Student Name",
											},
											{ id: "age", label: "Age" },
											{ id: "std", label: "Standard" },
											{ id: "div", label: "Division" },
											{ id: "ph", label: "Contact" },
											{ id: "edit", label: "Edit" },
											{ id: "delete", label: "Delete" },
										]}
										order={order}
										orderBy={orderBy}
										onRequestSort={handleSort}
										numSelected={selected.length}
										rowCount={compData.length}
										onSelectAllClick={handleSelectAllClick}
									/>
									<tbody>
										{displayedData?.map((row) => (
											<TableBody2
												key={row.srNo}
												id={row.srNo}
												zoneNm={row.zoneNm}
												schoolNm={row.schoolNm}
												studNm={row.studNm}
												age={row.age}
												std={row.std}
												div={row.div}
												ph={row.ph}
												serialNumber={row.serialNumber}
												//selected={selected.indexOf(row.srNo) !== -1}
												selected={selected.includes(
													row.srNo
												)}
												handleClick={(event) =>
													handleClick(event, row.srNo)
												}
											/>
										))}
									</tbody>
								</Table>
							</TableContainer>

							<Pagination
								currentPage={currentPage}
								handlePageChange={handlePageChange}
								handlePreviousPageRange={
									handlePreviousPageRange
								}
								visiblePageNumbers={visiblePageNumbers}
								pageNumber={pageNumbers}
								pageRange={pageRange}
								totalPages={totalPages}
								handleNextPageRange={handleNextPageRange}
							/>
						</Paper>
					</Grid>
				</Grid>
			</div>
		</>
	);
};

export default StudentRegWhatsapp;
